'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'door-closed';
var width = 448;
var height = 512;
var aliases = [128682];
var unicode = 'f52a';
var svgPathData = ['M80 64l0 400 288 0 0-400c0-8.8-7.2-16-16-16L96 48c-8.8 0-16 7.2-16 16zM336 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M352 48c8.8 0 16 7.2 16 16l0 400-288 0 0-400c0-8.8 7.2-16 16-16l256 0zm64 416l0-400c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 400-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0zM304 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorClosed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;